/**
 * Find and remove single-letter words at the end of the line by attaching hard spaces
 * @version 1.0.0
 * @author Bartłomiej Jedlikowski <jedlikowskib@gmail.com> for Laboratorium artystyczne
 * @website  https://laboratoriumartystyczne.pl/
 *
 */
class LASingleLettersBreaker {
  defaultOptions: IOptions
  options: IOptions
  initializedOptions: IOptions | Record<string, unknown>

  constructor(initializedOptions = {}) {
    // Default options to init with if user will not specified custom one
    this.defaultOptions = {
      autoInit: false,
      defaultSelector: 'p',
    }

    // Set default options as options to init
    this.options = this.defaultOptions

    // Get given options
    this.initializedOptions = initializedOptions

    // Override options with given
    this.options = Object.assign(this.options, this.initializedOptions)

    // Check if script should auto initialized itself if true, do it
    if (this.options.autoInit) {
      this._autoInit()
    }
  }

  /**
   * Find and attack hard space to every single letter inside specified container
   */
  init(target: Element) {
    target.innerHTML = target.innerHTML.replace(/\s([a-z])\s/g, ' $1&nbsp;')
  }

  /**
   * Auto init script for specified default selector
   */
  _autoInit() {
    // Find all elements with specified default selector
    const elementsToInit = document.querySelectorAll(
      this.options.defaultSelector
    )

    if (elementsToInit.length > 0) {
      elementsToInit.forEach((element) => {
        // Init functionality for every element
        this.init(element)
      })
    }
  }
}

interface IOptions {
  autoInit: boolean
  defaultSelector: string
}

export default LASingleLettersBreaker
